<template lang="html">
  <span>{{ outText }}</span>
</template>

<script>
import entityTexts from '@/config/entityTexts.json';
import entityStore from '@/store/entityStore';

export default {
  props: [
    'text',
  ],
  data() {
    return {
      entity: entityStore.state,
    };
  },
  computed: {
    outText() {
      let outText = `{{ ${this.text} }}`;

      // check if thers a string set for the entity and text
      if (entityTexts[this.text][this.entity.name]) {
        outText = entityTexts[this.text][this.entity.name];
      }

      // check if thers a default string set for the text
      else if (entityTexts[this.text]['default']) {
        outText = entityTexts[this.text]['default'];
      }

      return outText;
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// entityText.vue?f136322a